<div class="pkt-checkbox-tree">
  <div *ngFor="let node of nodes" class="pkt-tree-node">
    <div class="pkt-tree-parent">
      <mat-icon class="pkt-tree-chevron" (click)="toggleExpand(node)">{{ chevronIcon(isExpanded(node)) }}</mat-icon>
      <mat-checkbox [checked]="isParentChecked(node)" [indeterminate]="isParentIndeterminate(node)"
        [disabled]="disabled || !!node.disabled" (change)="onParentChange(node, $event.checked)">
        {{ node.label }}
      </mat-checkbox>
    </div>
    <div *ngIf="isExpanded(node)" class="pkt-tree-children">
      <kt-checkbox-group [options]="childOptions[node.value]" [disabled]="disabled" [ngModel]="childValues(node)"
        [ngModelOptions]="{standalone: true}" (ngModelChange)="onChildGroupChange(node, $event)"></kt-checkbox-group>
    </div>
  </div>
</div>